import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import Svg, { G, Path } from '@dbk/ui-svg';

function CreditviewIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="0 0 512 512"
    >
      <G fill={color} fillRule="evenodd">
  <G>
    <Path d="M469.256,175.503h-52.1v-73.542c0-23.569-19.175-42.744-42.744-42.744H42.744C19.175,59.218,0,78.393,0,101.962v191.786
      c0,23.569,19.175,42.744,42.744,42.744h52.102v73.546c0,23.569,19.175,42.744,42.744,42.744h331.666
      c23.569,0,42.744-19.175,42.744-42.744V218.247C512,194.678,492.825,175.503,469.256,175.503z M24.425,101.962
      c0-10.101,8.218-18.319,18.319-18.319h331.668c10.101,0,18.319,8.218,18.319,18.319v17.051H24.425V101.962z M94.846,218.247
      v93.819H42.744c-10.101,0-18.319-8.218-18.319-18.319v-93.743h74.52C96.32,205.54,94.846,211.725,94.846,218.247z M24.425,175.579
      v-32.14h368.306v32.064H137.59c-0.826,0-1.644,0.029-2.458,0.076H24.425z M469.256,428.357H137.59
      c-10.101,0-18.319-8.218-18.319-18.319V218.247c0-9.597,7.422-17.479,16.824-18.243H404.94c0.451,0,0.894-0.028,1.331-0.076
      h62.984c10.101,0,18.319,8.218,18.319,18.319v191.791h0.001C487.575,420.139,479.357,428.357,469.256,428.357z"/>
  </G>
</G>
<G>
  <G>
    <Path d="M340.211,255.272c-13.892,0-26.666,4.847-36.745,12.924c-10.333-8.324-23.209-12.931-36.829-12.931
      c-32.465,0-58.877,26.412-58.877,58.877c0,32.465,26.412,58.877,58.877,58.877c13.621,0,26.496-4.607,36.829-12.929
      c10.079,8.077,22.853,12.925,36.745,12.925c32.462,0,58.871-26.41,58.871-58.872C399.082,281.681,372.673,255.272,340.211,255.272
      z M287.953,341.201c-6.009,4.758-13.451,7.392-21.317,7.392c-18.997,0.001-34.452-15.454-34.452-34.45
      c0-18.997,15.455-34.452,34.452-34.452c7.866,0,15.307,2.635,21.317,7.392c-4.216,8.108-6.613,17.306-6.613,27.058
      C281.34,323.894,283.738,333.092,287.953,341.201z M340.211,348.589c-18.993,0-34.445-15.453-34.445-34.447
      c0-18.993,15.453-34.445,34.445-34.445c18.993,0,34.445,15.453,34.445,34.445C374.656,333.137,359.204,348.589,340.211,348.589z"
      />
  </G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
<G>
</G>
</Svg>
  );
}

CreditviewIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

CreditviewIcon.defaultProps = {
  height: 24,
  width: 24,
};

export default pure(CreditviewIcon);
